import { UtmSource } from '../../../../../../services/exports/Constants';
import { CustomUtmSource } from '../../../../../../views/marketing/tracking-links';

export default {
  title: 'Sporingslinks',
  utm_sources: {
    [UtmSource.GoogleBusinessProfile]: 'Google Business',
    [UtmSource.SocialMedia]: 'Sociale medier',
  },
  form: {
    utm_source: {
      label: 'Kilde',
      placeholder: 'Vælg kilde',
      options: {
        [UtmSource.GoogleBusinessProfile]: 'Google Business',
        [UtmSource.SocialMedia]: 'Andre sociale medier',
        [CustomUtmSource.Other]: 'Andet',
      },
    },
    utm_source_details: {
      label: 'Brugerdefineret kilde',
      placeholder: 'Angiv kilde',
    },
    target_product: {
      label: 'Mål',
      placeholder: 'Vælg mål',
    },
    target_url: {
      label: 'Mål-URL',
      placeholder: 'https://google.com',
    },
    utm_medium: {
      label: 'Medie',
      placeholder: 'Angiv medie',
    },
    utm_campaign: {
      label: 'Kampagne',
      placeholder: 'Angiv kampagne',
    },
  },
  fields: {
    utm_source: 'Kilde',
    target_product: 'Mål',
    type: 'Type',
    utm_medium: 'Medie',
    utm_campaign: 'Kampagne',
    utm_referrer_id: 'Henviser-ID',
  },
  buttons: {
    create_auto_links: 'Opret automatiske links',
    create_link: 'Opret link',
    create: 'Opret',
    update: 'Opdater',
    copy_link: 'Kopiér link',
    download_qr_code: 'Download QR-kode',
    edit: 'Rediger',
  },
  modals: {
    auto_links_creation: {
      title: 'Er du sikker?',
      description:
        'Sørg for, at du er færdig med butiksopsætningen (onlineshoppens subdomæne / butikkens domæne). Ændringer efter oprettelse af links påvirker ikke automatisk de eksisterende links!',
    },
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne er gemt',
    link_got_copied: 'Linket er kopieret!',
    failed_to_download_qr_code: 'QR-koden kunne ikke downloades',
  },
};
